import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSharesTransferModal } from '../context/SharesTransferModalContext';

const SharesTransferModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSharesTransferModal();

  const titles: { [key: string]: string } = {
    SELL_PARTICIPATION: t('SaleOfShares'),
    HERITAGE: t('Heritage'),
    DONATION: t('Donation'),
    ENDORSEMENT: t('Endorsement'),
    TRANSMISSION: t('Transmission'),
  };

  const title = titles[data.operationType];

  return (
    <Modal.Header>
      <h5 className="modal-title">{title}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default SharesTransferModalHeader;
